import { useCallback } from "react";
import { NumberString } from "./NumberString";

interface Props extends React.RefAttributes<HTMLInputElement> {
  name?: string;
  label?: string;
  value: string;
  maxLength?: number;
  required?: boolean;
  error?: string;
  placeholder?: string;
  labelBgClass?: string;
  withAsterisk?: boolean;
  disabled?: boolean;
  className?: string;
  onChange: (value: string) => void;
}

// Final solution - kết hợp cả UX và technical excellence
export const PostalCodeInput: React.FC<Props> = ({
  value,
  label,
  error,
  placeholder,
  onChange,
}) => {
  const formatValue = useCallback((raw: string): string => {
    if (!raw) return "";
    const numbersOnly = raw?.replace(/\D/g, "");
    if (numbersOnly?.length <= 3) return numbersOnly;
    return `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3, 7)}`;
  }, []);

  return (
    <NumberString
      label={label}
      value={value}
      onChange={(value) => {
        onChange(value)
      }}
      placeholder={placeholder}
      maxLength={8} // 7 numbers + 1 dash
      error={error}
      onBlur={(v) => {
        onChange(formatValue(v))
      }}
    />
  );
};
